import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import Select from "react-select";
import axios from "axios";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};
const AddSuppliers = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [stateDrp, setStateDrpData] = useState([]);
  const [cityDrp, setCityDrpData] = useState([]);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    city_id: "",
    state_id: "",
    address: "",
    gst_no: "",
    country_id: 101,
    contact_no: "",
  });

  const getStateDrpData = () => {
    axios
      .post(API_URL.STATE_LIST, { country_id: formValue.country_id })
      .then((res) => {
        setStateDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setStateDrpData(cd);
      });
  };

  const getCityDrpData = () => {
    axios
      .post(API_URL.CITY_LIST, { state_id: formValue.state_id })
      .then((res) => {
        setCityDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setCityDrpData(cd);
      });
  };

  const onEdit = () => {
    axios.post(API_URL.PARTY_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          city_id: res.data.data.city_id ? res.data.data.city_id : "",
          country_id: res.data.data.country_id ? res.data.data.country_id : 101,
          state_id: res.data.data.state_id ? res.data.data.state_id : "",
          address: res.data.data.address
            ? res.data.data.address
            : "",
          gst_no: res.data.data.gst_no ? res.data.data.gst_no : "",
          contact_no: res.data.data.contact_no ? res.data.data.contact_no : "",
        });
      }
    });
  };

  const onSave = () => {
    if (
      formValue.name &&
      formValue.city_id &&
      formValue.state_id &&
      formValue.contact_no
    ) {
      setError(false);
      setLoading(true);
      const pUrl = id ? API_URL.PARTY_UPDATE : API_URL.PARTY_SAVE;
      axios.post(pUrl, {...formValue, is_seller: 1}).then((res) => {
        if (res.data.status === 1) {
          let message = id
            ? "Supplier Updated Successfully."
            : "Supplier Created Successfully.";
          toast.success(message, { autoClose: 3000, position: "top-right" });
          setLoading(false);
          navigate("/purchase/suppliers");
        }
      })
        .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const isRequiredField = (key) => {
    return isError && !formValue[key];
  };
  
  const setFormData = (name, value) => {
    setFormValue({ ...formValue, [name]: value });
  };

  useEffect(() => {
    getCityDrpData();
  }, [formValue.state_id]);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  useEffect(() => {
    getStateDrpData();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Supplier</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/purchase/suppliers"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Name<span className="required-star">*</span></label>
                      <input
                        type="text"
                        value={formValue.name}
                        onChange={(e) => setFormData("name", e.target.value)}
                        className={
                          isRequiredField("name")
                            ? "form-control required"
                            : "form-control"
                        }
                        placeholder="Enter Name"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Contact Number<span className="required-star">*</span></label>
                      <input
                        type="text"
                        value={formValue.contact_no}
                        onChange={(e) => setFormData("contact_no", e.target.value)}
                        className={
                          isRequiredField("contact_no")
                            ? "form-control required"
                            : "form-control"
                        }
                        placeholder="Contact Number"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>State<span className="required-star">*</span></label>
                      <Select
                        options={stateDrp}
                        value={stateDrp.find((r) => r.value == formValue.state_id)}
                        styles={
                          isRequiredField("state_id")
                            ? customRequireStyles
                            : customStyles
                        }
                        onChange={(e) => setFormValue({ ...formValue, state_id: e.value })}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label htmlFor="City">City<span className="required-star">*</span></label>
                      <Select
                        options={cityDrp}
                        value={cityDrp.find((r) => r.value == formValue.city_id)}
                        styles={
                          isRequiredField("city_id")
                            ? customRequireStyles
                            : customStyles
                        }
                        onChange={(e) =>
                          setFormValue({ ...formValue, city_id: e.value })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Address</label>
                      <input
                        type="text"
                        value={formValue.address}
                        onChange={(e) => setFormData("address", e.target.value)}
                        className="form-control"
                        placeholder="Address"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>GST Number</label>
                      <input
                        type="text"
                        value={formValue.gst_no}
                        onChange={(e) => setFormData("gst_no", e.target.value)}
                        className="form-control"
                        placeholder="GST Number"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group text-right">
                      <button
                        type="submit"
                        onClick={onSave}
                        disabled={ loading}
                        className="btn btn-primary"
                      >
                        {loading ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Watch color={"white"} height={20} width={20} />
                          </div>
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSuppliers;
